<template>
  <v-footer
    color="secondary"
    padless
  >
    <v-container>
      <v-row
        justify="center"
        no-gutters
      >
        <template v-if="censored">
          <v-col class="py-4 text-center" cols="12">{{ new Date().getFullYear() }} — <strong>MyGallery</strong></v-col>
        </template>
        <template v-else>
          <v-col class="py-4 text-center" cols="12">{{ new Date().getFullYear() }} — <strong>Genshin Hentai</strong></v-col>
          <v-btn :to="{ name: 'TermsOfService' }" text rounded class="ma-2">Terms of Service</v-btn>
          <v-btn :to="{ name: 'PrivacyPolicy' }" text rounded class="ma-2">Privacy Policy</v-btn>
          <v-btn :to="{ name: 'Upload' }" text rounded class="ma-2">Upload</v-btn>
        </template>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  computed: {
    censored () {
      return process.env.VUE_APP_CENSORED === 'true'
    }
  }
}
</script>
